export const CErrorContext = {
    DEFAULT: 'DEFAULT',
    ADD_TEEN: 'ADD_TEEN',
    SEND_MONEY: 'SEND_MONEY',
    KYC:'KYC'
} as const;

